<template>
  <div class="create_wrapper">
    <!-- Start Breadcrumb -->
    <Breadcrumb :items="items" />
    <!-- End Breadcrumb -->

    <div class="custom_card">
      <div class="card-header">
        <h4 class="card-title">{{ $t("addNew") }}</h4>
      </div>

      <!-- ==== Start Form ==== -->
      <form @submit.prevent="validateForm">
        <div class="container">
          <div class="row justify-content-between">
            <div class="col-12 py-0">
              <uplode-image
                @inputChanged="uplodeImg_1"
                placeHolder="صورة الفرع"
              ></uplode-image>
              <!-- End:: Image -->
            </div>
            <!-- Start:: Image -->
            <!-- Start:: countery -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.ar.title"
                />
                <label for="name_input" class="form-label"
                  >اسم الفرع (عربي)</label
                >
              </div>
            </div>
            <!-- End:: Ar countery -->

            <!-- Start:: En countery -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.en.title"
                />
                <label for="name_input" class="form-label"
                  >اسم الفرع (إنجليزي)</label
                >
              </div>
            </div>
            <!-- End:: En countery -->

            <!-- Start:: Ar desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isArabic"
                  v-model.trim="data.ar.desc"
                />
                <label for="name_input" class="form-label"
                  >العنوان بالتفصيل(عربي)</label
                >
              </div>
            </div>
            <!-- End:: Ar desc-->

            <!-- Start:: En desc -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="text"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  @keypress="isEnglish"
                  v-model.trim="data.en.desc"
                />
                <label for="name_input" class="form-label"
                  >العنوان بالتفصيل(إنجليزي)</label
                >
              </div>
            </div>
            <!-- End:: En desc -->

            <!-- Start:: email -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <input
                  type="email"
                  class="form-control"
                  @input="helper_checkIfInputIsEmpty"
                  v-model.trim="data.email"
                />
                <label for="name_input" class="form-label"
                  >البريد الالكتروني</label
                >
              </div>
            </div>
            <!-- End::  email -->
            <!-- Start::  Phone Code -->
            <!-- Project Phone code Input -->
            <div class="col-lg-6 py-0">
              <div class="input_wrapper top_label">
                <label for="name_input" class="form-label"> كود الدولة</label>
                <multiselect
                  v-model="data.phoneCode"
                  :options="PhoneCodes"
                  label="key"
                  track-by="key"
                  placeholder=" "
                  :searchable="true"
                  :allow-empty="true"
                  :show-labels="false"
                >
                  <template slot="option" slot-scope="props">
                    <img class="option__image" :src="props.option.flag" />
                    <div class="option__desc d-flex justify-between">
                      <span class="option__title">
                        {{ props.option.key }}
                      </span>
                    </div>
                  </template>
                </multiselect>
              </div>
            </div>
            <!-- End:: Phone Code -->
            <!-- Phone -->
            <div class="repeater_wrapper mt-6">
              <h5>ارقام الهاتف</h5>
              <div class="row">
                <div
                  class="col-lg-6"
                  v-for="(item, itemIndex) in data.phones"
                  :key="itemIndex"
                >
                  <div class="row">
                    <!-- ********** Row Data ********** -->
                    <div class="col-9">
                      <div class="input_wrapper top_label">
                        <input
                          type="number"
                          class="form-control"
                          @input="helper_checkIfInputIsEmpty"
                          v-model.trim="item.value"
                        />
                        <label for="name_input" class="form-label"
                          >رقم الهاتف</label
                        >
                      </div>
                    </div>

                    <!-- ********** Row Control Buttons ********** -->
                    <div
                      class="col-1 py-0 d-flex justify-center align-center mx-1"
                    >
                      <span class="append" @click="appendRow">
                        <i class="fas fa-plus-circle"></i>
                      </span>
                    </div>
                    <div
                      class="col-1 py-0 d-flex justify-center align-center mx-1"
                    >
                      <span
                        v-if="data.phones.length > 1 && itemIndex > 0"
                        class="append"
                        @click="deleteRow(itemIndex)"
                      >
                        <i class="fas fa-minus-circle"></i>
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- Start:: Map -->
            <div class="col-lg-12 top_label row">
              <!-- <div class=""> -->
              <!-- v-if="data.area" -->
              <!-- <base-map
                  @markersChanged="merkersChanged"
                
                /> -->
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.lng"
                  />
                  <label for="name_input" class="form-label">خط الطول</label>
                </div>
              </div>
              <div class="col-lg-6 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.lat"
                  />
                  <label for="name_input" class="form-label">دائرة عرض</label>
                </div>
              </div>
              <div class="col-lg-12 py-0">
                <div class="input_wrapper top_label">
                  <input
                    type="text"
                    class="form-control"
                    @input="helper_checkIfInputIsEmpty"
                    v-model.trim="data.location_url"
                  />
                  <label for="name_input" class="form-label">رابط الموقع</label>
                </div>
              </div>
              <!-- <searchMap @get-loaction="merkersChanged" :location="data.mapCenter"/> -->
              <!-- <label for="name_input" class="form-label">{{
                  $t("forms.labels.area")
                }}</label> -->
              <!-- </div> -->
            </div>
            <!-- end:: Map -->
          </div>
        </div>

        <div class="buttons_wrapper">
          <button class="base-btn">
            {{ $t("forms.submit") }}
            <span class="btn_loader" v-if="btnIsLoading"></span>
          </button>
        </div>
      </form>
      <!-- ==== End Form ==== -->
    </div>
  </div>
</template>

<script>
import searchMap from "@/components/Maps/SearchMap.vue";
import selectCodePhone from "@/components/UI/BaseCountryFlagPhoneInput.vue";
export default {
  name: "Create",
  components: {
    searchMap,
    selectCodePhone,
  },
  data() {
    return {
      // ========== Breadcrumbs
      items: [
        {
          text: this.$t("breadcrumb.mainPage"),
          disabled: false,
          href: "/",
        },
        {
          text: this.$t("breadcrumb.branches.title"),
          disabled: false,
          href: "/branches",
        },
        {
          text: this.$t("breadcrumb.branches.add"),
          disabled: true,
          href: "",
        },
      ],

      // ========== Loading
      btnIsLoading: false,

      // ========== Data
      data: {
        image: null,
        ar: {
          title: null,
          desc: null,
        },
        en: {
          title: null,
          desc: null,
        },
        phones: [
          {
            value: null,
          },
        ],
        mapCenter: {
          lat: null,
          lng: null,
        },
        lat: null,
        lng: null,
        location_url: null,
        email: null,
        phoneCode: null,
        area: JSON.parse(localStorage.getItem("vendor_country_map_area"))
          ? JSON.parse(localStorage.getItem("vendor_country_map_area"))
          : [],
      },
      PhoneCodes: [],
    };
  },

  methods: {
    // Change Phone Code
    phonecodeChanged() {
      // this.data.phoneCode = data
    },
    appendRow() {
      this.data.phones.push({
        value: null,
      });
    },
    deleteRow(itemIndex) {
      this.data.phones.splice(itemIndex, 1);
    },
    uplodeImg_1(obj) {
      this.data.image = obj?.img_file;
    },
    merkersChanged(data) {
      this.data.mapCenter = data.mapCenter;
    },

    // Empty Form Data
    emptyFormData() {
      this.data.email = null;
      this.data.image = null;
      this.data.ar.title = null;
      this.data.en.title = null;
      this.data.mapCenter = null;
      this.data.ar.desc = null;
      this.data.en.desc = null;
      this.data.lat = null;
      this.data.lng = null;
      (this.data.phoneCode = null),
        (this.data.phones = [
          {
            value: null,
          },
        ]);
    },

    // Validate Data
    validateForm() {
      this.btnIsLoading = true;

      if (!this.data.image) {
        this.$iziToast.error({
          timeout: 2000,
          message: "الصورة مطلوبه",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل اسم الفرع بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.title) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل اسم الفرع بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.ar.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل  العنوان التفصيلي للفرع بالعربي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.en.desc) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل العنوان التفصيلي للفرع بالانجليزي",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.email) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل البريد الالكتروني",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phoneCode) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل كود الدولة  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.phones.length > 0) {
        this.$iziToast.error({
          timeout: 2000,
          message: "  ادخل علي الاقل رقم هاتف واحد  ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.lng) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ادخل  قيمة خط الطول",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else if (!this.data.lat) {
        this.$iziToast.error({
          timeout: 2000,
          message: " ادخل  قيمة دائرة العرض ",
          position: "bottomRight",
        });
        this.btnIsLoading = false;
        return;
      } else {
        this.submitData();
        return;
      }
    },

    // Submit Data
    submitData() {
      const submit_data = new FormData();
      if (this.data.image) {
        submit_data.append("main_image", this.data.image);
      }
      submit_data.append("branch_email", this.data.email);
      submit_data.append("ar[title]", this.data.ar.title);
      submit_data.append("en[title]", this.data.en.title);
      submit_data.append("ar[description]", this.data.ar.desc);
      submit_data.append("en[description]", this.data.en.desc);
      submit_data.append("lat", this.data.lat);
      submit_data.append("lng", this.data.lng);
      submit_data.append("location_url", this.data.location_url);
      // submit_data.append(`phone_code`, this.data.phoneCode.key);
      // submit_data.append("lat", this.data.mapCenter?.lat);
      // submit_data.append("lng", this.data.mapCenter?.lng);

      submit_data.append(`phone_code`, this.data.phoneCode.key);
      this.data.phones.forEach((item, index) => {
        submit_data.append(`branch_phones[${index}][phone]`, item.value);
        submit_data.append(
          `branch_phones[${index}][phone_code]`,
          this.data.phoneCode.key
        );
      });

      this.axios({
        method: "POST",
        url: "branch",
        data: submit_data,
      })
        .then((res) => {
          this.$iziToast.success({
            timeout: 2000,
            message: res.data.message,
            position: "bottomRight",
          });
          this.$router.push({ path: "/branches" });
          this.btnIsLoading = false;
          this.emptyFormData();
        })
        .catch((err) => {
          this.$iziToast.error({
            timeout: 2000,
            message: err.response.data.message,
            position: "bottomRight",
          });
          this.btnIsLoading = false;
        });
    },

    // Get Phone Codes
    getPhoneCodes() {
      this.axios({
        method: "GET",
        url: `phone_code`,
      })
        .then((res) => {
          this.PhoneCodes = res.data.data.map((item) => {
            return {
              // id: item.id,
              key: item.phone_code,
              flag: item.flag,
            };
          });

          // ********** Start:: Set Initial Selected Key **********

          // if (this.preSelectedPhoneCode) {
          //   this.selectedCountry = this.countriesKeys.find(
          //     (country) => country.key == this.preSelectedPhoneCode
          //   )
          //   this.updateSelectedCountryKeyValue()
          // } else {
          //   this.selectKey(this.countriesKeys[0])
          //   this.toggleCountriesKeysMenu()
          // }

          // ********** End:: Set Initial Selected Key **********
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
  mounted() {
    this.getPhoneCodes();
  },
};
</script>
